import moment from "moment/moment";
import momentTz from "moment-timezone";
import * as Muicon from "@mui/icons-material";
import { Chip } from "@mui/material";
import { createElement, memo, useEffect, useRef, useState } from "react";
import * as Icons from "@mui/icons-material";
import { baseUrl, colorToStatus, endpoints, userRole } from "./config";
import { orderStatus } from "./API/api-utils";

export const defaultColDef = {
  editable: true,
  flex: 0,
  minWidth: 100,
  //  filter: true,
  //  floatingFilter: true,
  //  suppressHeaderMenuButton: true,
  enableCellChangeFlash: false,
};

export const getRowId = (params) => String(params.data.id);

export const toolPanelStyles = {
  width: "100%",
  height: "40px",
  display: "flex",
  padding: "5px",
};

export const biletColumns = [
  {
    field: "name",
    headerName: "Название билета",
    flex: 1,
    filter: "agTextColumnFilter",
    headerTooltip: "Название билета",
  },

  {
    field: "description",
    headerName: "Комментарий",
    flex: 1,
    filter: "agTextColumnFilter",
    headerTooltip: "Комментарий администратора к билету",
  },
  {
    field: "question_count",
    headerName: "Кол-во вопросов",
    flex: 1,
    filter: "agTextColumnFilter",
    headerTooltip: "Колличество вопросов в каждом билете",
  },
];

export const questionColumns = [
  {
    field: "text",
    headerName: "Текст вопроса",
    flex: 1,
    filter: "agTextColumnFilter",
    headerTooltip: "Текст вопроса",
  },
  {
    field: "description",
    headerName: "Коментарий",
    flex: 1,
    filter: "agTextColumnFilter",
    headerTooltip: "Коментарий администратора",
  },
  {
    field: "image_src",
    headerName: "Картинка",
    flex: 1,

    cellRenderer: memo(({ value }) => {
      const ref = useRef(null);
      const [visible, setVisible] = useState(false);

      useEffect(() => {
        if (!value) return;

        const observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              setVisible(true);
              observer.disconnect();
            }
          },
          { rootMargin: "150px" },
        );

        if (ref.current) observer.observe(ref.current);

        return () => observer.disconnect();
      }, [value]);

      return (
        <span
          ref={ref}
          style={{
            display: "flex",
            height: "100%",
            width: "100%",
            alignItems: "center",
            justifyContent: "center",
          }}>
          {visible ? (
            <img
              alt="Вопрос без рисунка"
              src={`${baseUrl}/image/test/${value}`}
              style={{
                maxHeight: "100%",
                display: "block",
                filter: "brightness(1.2)",
              }}
            />
          ) : (
            <div style={{ width: 40, height: 40, background: "#eee" }} />
          )}
        </span>
      );
    }),

    filter: "agTextColumnFilter",
    headerTooltip: "Визуальное пояснение к билету",
  },
  {
    field: "error_text",
    headerName: "Объяснение",
    flex: 1,
    filter: "agTextColumnFilter",
    headerTooltip: "Объяснение в случае не верного ответа",
  },
];

export const questionColumnsMinimized = [
  {
    field: "text",
    headerName: "Текст вопроса",
    flex: 1,
    filter: "agTextColumnFilter",
    headerTooltip: "Текст вопроса",
  },
];

export const themeColumns = [
  {
    field: "theme_number",
    headerName: "Номер темы",
    flex: 0.1,
    filter: "agTextColumnFilter",
    headerTooltip: "Порядковый номер темы",
  },
  {
    field: "theme_subnumber",
    headerName: "Номер подтемы",
    flex: 0.1,
    filter: "agTextColumnFilter",
    headerTooltip: "Порядковый номер подтемы",
  },
  {
    field: "name",
    headerName: "Название темы",
    flex: 1,
    filter: "agTextColumnFilter",
    headerTooltip: "Название темы, по которой группируются билеты",
  },

  {
    field: "description",
    headerName: "Комментарий",
    flex: 1,
    filter: "agTextColumnFilter",
    headerTooltip: "Комментарий администратора к билету",
  },
];

export const themeColumnsMinimized = [
  {
    field: "name",
    headerName: "Название темы",
    flex: 1,
    filter: "agTextColumnFilter",
    headerTooltip: "Название темы, по которой группируются билеты",
  },
];

export const pddColumns = [
  {
    field: "theme_number",
    headerName: "Номер темы",
    flex: 0.5,
    filter: "agTextColumnFilter",
    headerTooltip: "",
  },
  {
    field: "theme_subnumber",
    headerName: "Номер подтемы",
    flex: 0.5,
    filter: "agTextColumnFilter",
    headerTooltip: "",
  },
  {
    field: "theme_name",
    headerName: "Название темы",
    flex: 0.5,
    filter: "agTextColumnFilter",
    headerTooltip: "",
  },
  {
    field: "text",
    headerName: "Текст документа",
    flex: 3,
    filter: "agTextColumnFilter",
    headerTooltip: "",
  },
];

export const videoColumns = [
  {
    field: "name",
    headerName: "Название видео",
    flex: 1,
    filter: "agTextColumnFilter",
    headerTooltip: "",
  },
  {
    field: "theme_name",
    headerName: "Название темы",
    flex: 1,
    filter: "agTextColumnFilter",
    headerTooltip: "",
  },
  {
    field: "video_src",
    headerName: "Видеофайл",
    flex: 1,
    filter: "agTextColumnFilter",
    headerTooltip: "",
  },
  {
    field: "preview_src",
    headerName: "Превью",
    flex: 1,
    filter: "agTextColumnFilter",
    headerTooltip: "",
    cellRenderer: memo(({ value }) => {
      const ref = useRef(null);
      const [visible, setVisible] = useState(false);

      useEffect(() => {
        if (!value) return;

        const observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              setVisible(true);
              observer.disconnect();
            }
          },
          { rootMargin: "150px" },
        );

        if (ref.current) observer.observe(ref.current);

        return () => observer.disconnect();
      }, [value]);

      return (
        <span
          ref={ref}
          style={{
            display: "flex",
            height: "100%",
            width: "100%",
            alignItems: "center",
            justifyContent: "center",
          }}>
          {visible ? (
            <img
              alt="Вопрос без рисунка"
              src={`${baseUrl}/image/preview/${value}`}
              style={{
                maxHeight: "100%",
                display: "block",
                filter: "brightness(1.2)",
              }}
            />
          ) : (
            <div style={{ width: 40, height: 40, background: "#eee" }} />
          )}
        </span>
      );
    }),
  },
];

export const newsColumns = [
  {
    field: "title",
    headerName: "Заголовок",
    flex: 1,
    filter: "agTextColumnFilter",
    headerTooltip: "Загловок нвости",
  },
  {
    field: "short_text",
    headerName: "Краткое содержание",
    flex: 1,
    filter: "agTextColumnFilter",
    headerTooltip: "Краткое содержание новости",
  },
  {
    field: "full_text",
    headerName: "Текст новости",
    flex: 1,
    filter: "agTextColumnFilter",
    headerTooltip: "Развернутое текстовое наполнение",
  },

  {
    field: "date",
    headerName: "Дата создания",
    flex: 1,
    filter: "agTextColumnFilter",
    headerTooltip: "Дата создания",
    cellRenderer: (data) => {
      return moment.unix(data.value).format("MM/DD/YYYY HH:mm");
    },
  },
];

export const schoolColumns = [
  {
    field: "name",
    headerName: "Название автошколы",
    flex: 1,
    filter: "agTextColumnFilter",
    headerTooltip: "Загловок нвости",
  },
  {
    field: "description",
    headerName: "Комментарий",
    flex: 1,
    filter: "agTextColumnFilter",
    headerTooltip: "Краткое содержание новости",
  },
  {
    field: "phone",
    headerName: "Телефон автошколы ",
    flex: 1,
    filter: "agTextColumnFilter",
    headerTooltip: "Развернутое текстовое наполнение",
  },

  {
    field: "city",
    headerName: "Город автошколы",
    flex: 1,
    filter: "agTextColumnFilter",
    headerTooltip: "Дата создания",
  },

  {
    field: "ref_code",
    headerName: "Код приглашения автошколы",
    flex: 1,
    filter: "agTextColumnFilter",
    headerTooltip: "Дата создания",
  },

  {
    field: "director_name",
    headerName: "ФИО директора",
    flex: 1,
    filter: "agTextColumnFilter",
    headerTooltip: "Дата создания",
  },
  {
    field: "director_phone",
    headerName: "Телефон директора",
    flex: 1,
    filter: "agTextColumnFilter",
    headerTooltip: "Дата создания",
  },
];
export const groupColumns = [
  {
    field: "name",
    headerName: "Название группы",
    flex: 1,
    filter: "agTextColumnFilter",
    headerTooltip: "Название группы",
  },
  {
    field: "description",
    headerName: "Комментарий",
    flex: 1,
    filter: "agTextColumnFilter",
    headerTooltip: "комментарий к группе",
  },
  {
    headerName: "Кол-во. сотрудников",
    flex: 1,
    filter: "agTextColumnFilter",
    headerTooltip: "Колличество сотрудников в конкретной группе",
  },
];

export const userMinifideColums = [
  {
    field: "name",
    headerName: "ФИО пользователя",
    flex: 1,
    filter: "agTextColumnFilter",
    headerTooltip: "",
  },
  {
    field: "login",
    headerName: "Логин",
    flex: 1,
    filter: "agTextColumnFilter",
    headerTooltip: "",
  },
];

export const userColumns = [
  {
    field: "name",
    headerName: "ФИО пользователя",
    flex: 1,
    filter: "agTextColumnFilter",
    headerTooltip: "",
  },
  {
    field: "login",
    headerName: "Логин",
    flex: 1,
    filter: "agTextColumnFilter",
    headerTooltip: "",
  },
  {
    field: "school_name",
    headerName: "Автошкола",
    flex: 1,
    filter: "agTextColumnFilter",
    headerTooltip: "",
    cellRenderer: (data) => {
      return data.value || "Не прикреплен";
    },
  },
  {
    field: "description",
    headerName: "Комментарий",
    flex: 1,
    filter: "agTextColumnFilter",
    headerTooltip: "",
  },

  {
    field: "role",
    headerName: "Тип учетной записи",
    flex: 0.4,
    filter: "agTextColumnFilter",
    headerTooltip: "",
    cellRenderer: ({ data }) => {
      return userRole[data.role];
    },
  },
  // s
  // {
  //   field: "is_delete",
  //   headerName: "Удален",
  //   flex: 1,
  //   filter: "agTextColumnFilter",
  //   headerTooltip: "",
  // },

  // {
  //   field: "",
  //   headerName: "Заблокирован",
  //   flex: 1,
  //   filter: "agTextColumnFilter",
  //   headerTooltip: "",
  // },
];

export const SessonColumns = [
  {
    field: "id",
    headerName: "№",
    flex: 1,
    filter: "agTextColumnFilter",
    headerTooltip: "№",
  },
  {
    field: "device_name",
    headerName: "Привязанное устройство",
    flex: 1,
    filter: "agTextColumnFilter",
    headerTooltip: "Имя привязанного устройства",
  },
  {
    field: "session_id",
    headerName: "Сессия",
    flex: 1,
    filter: "agTextColumnFilter",
    headerTooltip: "Идентификатор сесси пользователя",
  },
  {
    field: "created_at",
    headerName: "Дата создания",
    flex: 1,
    filter: "agTextColumnFilter",
    headerTooltip: "Дата предоставления ус-ву безсрочной сесси",
    cellRenderer: (data) => {
      const { value: created_at } = data;
      console.log(created_at);
      const parsedDate = momentTz.utc(created_at);
      console.log("Валидна ли дата?:", parsedDate.isValid()); // Должно быть true

      // Переводим UTC-время в локальное время Кишинева и форматируем
      return parsedDate.tz("Europe/Chisinau").format("LLL");
    },
  },
];

export const newsThemeColumn = [
  {
    field: "name",
    headerName: "Название категории",
    flex: 1,
    filter: "agTextColumnFilter",
    headerTooltip: "Название категори",
  },
  {
    headerName: "Иконка",
    flex: 1,
    filter: "agTextColumnFilter",
    headerTooltip: "Изображение категории",
    cellRenderer: (data) => {
      const { main_color, text_color, name, icon_name } = data.data;
      return (
        <Chip
          sx={{
            backgroundColor: main_color,
            color: text_color,
            borderRadius: "8px",
          }}
          label={name}
          icon={Icons[icon_name] ? createElement(Icons[icon_name]) : null}
        />
      );
    },
  },
];

export const DrivingTimeColumn = [
  {
    field: "name",
    headerName: "Название категории",
    flex: 1,
    filter: "agTextColumnFilter",
    headerTooltip: "Название категори",
  },
  {
    field: "driving_time",
    headerName: "Назначенные часы",
    flex: 1,
    filter: "agTextColumnFilter",
    headerTooltip: "Название категори",
  },
];

export const autoColumns = [
  {
    field: "license_plate",
    headerName: "Гос.номер",
    filter: "agTextColumnFilter",
    flex: 1,

    headerTooltip: "Гос.номер",
  },
  {
    field: "brend",
    headerName: "Бренд авто",
    filter: "agTextColumnFilter",
    flex: 1,

    headerTooltip: "Бренд авто",
  },
  {
    field: "model",
    headerName: "Модель",
    filter: "agTextColumnFilter",
    flex: 1,

    headerTooltip: "Модель",
  },
  {
    field: "category_name",
    headerName: "Категория",
    filter: "agTextColumnFilter",
    flex: 1,
    headerTooltip: "Модель",
  },
  {
    field: "status",
    headerName: "Статус авто",
    filter: "agTextColumnFilter",
    flex: 1,

    headerTooltip: "Активен, в ремонте, удалент и т.п.",
    cellRenderer: (data) => {
      const status = data.data.status;

      switch (status) {
        case "active":
          return (
            <Chip
              sx={{
                borderRadius: "8px",
                marginLeft: "8px",
              }}
              color={"success"}
              label={"Активно"}
            />
          );
        case "deleted":
          return (
            <Chip
              sx={{
                borderRadius: "8px",
                marginLeft: "8px",
              }}
              color={"error"}
              label={"Удалено"}
            />
          );
        case "service":
          return (
            <Chip
              sx={{
                borderRadius: "8px",
                marginLeft: "8px",
              }}
              color={"warn"}
              label={"В ремонте"}
            />
          );
        default:
          break;
      }
    },
  },
];

export const orderColumns = [
  {
    field: "id",
    headerName: "№",
    flex: 0.08,
    filter: "agTextColumnFilter",
    headerTooltip: "Номер заявки",
  },
  {
    field: "name",
    headerName: "Имя студента",
    flex: 1,
    filter: "agTextColumnFilter",
    headerTooltip: "Имя студента",
  },
  {
    field: "phone",
    headerName: "Номер телефона",
    flex: 1,
    filter: "agTextColumnFilter",
    headerTooltip: "Номер телефона",
  },
  {
    field: "categories",
    headerName: "Категории",
    flex: 1,
    filter: "agTextColumnFilter",
    headerTooltip: "Категории",
    cellRenderer: (data) => {
      const cats = data.data.categories;

      return cats.map(({ name }) => (
        <Chip
          sx={{
            borderRadius: "8px",
            marginLeft: "8px",
          }}
          label={name}
        />
      ));
    },
  },
  {
    field: "status",
    headerName: "Статус заявки",
    flex: 1,
    filter: "agTextColumnFilter",
    headerTooltip: "Статус заявки",
    cellRenderer: (data) => {
      const status = data.data.status;

      return (
        <Chip
          sx={{
            borderRadius: "8px",
            marginLeft: "8px",
          }}
          color={orderStatus[status].color}
          label={orderStatus[status].text}
        />
      );
    },
  },
  // {
  //   headerName: "Иконка",
  //   flex: 1,
  //   filter: "agTextColumnFilter",
  //   headerTooltip: "Изображение категории",
  //   cellRenderer: (data) => {
  //     const { main_color, text_color, name, icon_name } = data.data;
  //     return (
  //       <Chip
  //         sx={{
  //           backgroundColor: main_color,
  //           color: text_color,
  //           borderRadius: "8px",
  //         }}
  //         label={name}
  //         icon={Icons[icon_name] ? createElement(Icons[icon_name]) : null}
  //       />
  //     );
  //   },
  // },
];

export const getUserRowStyle = (values) => {
  if (values.data.is_delete) {
    return { background: colorToStatus.block };
  } else if (values.data.is_block) {
    return { background: colorToStatus.delete };
  }
};
